/* eslint-disable @typescript-eslint/naming-convention */
import {Injectable} from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth';
import {AngularFireDatabase} from '@angular/fire/database';
import {AngularFirestore} from '@angular/fire/firestore';
import {Observable, of} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {Cliente} from 'src/app/model/cliente.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  static CLIENTS_REF = 'clients';

  pn;
  uid;

  errors = {
    'auth/captcha-check-failed': 'Errore Captcha, assicurati di aver risolto correttamente il puzzle.',
    'auth/invalid-phone-number': 'Errore, il numero di telefono inserito non è corretto.',
    'auth/missing-phone-number': 'Errore, numero di telefono mancante.',
    'auth/quota-exceeded': 'Errore quota, contatta la direzione.',
    'auth/user-disabled': 'Errore, utente disabilitato. Contatta la direzione.',
    'auth/operation-not-allowed': 'Errore sconosciuto. Contatta la direzione.',
    'auth/invalid-verification-code': 'Errore, codice inserito non valido.'
  };

  userData$: Observable<Cliente>;

  private _isAuthenticated = false;

  constructor(
    private afAuth: AngularFireAuth,
    private db: AngularFireDatabase,
    private afs: AngularFirestore
  ) {

    this.userData$ = this.afAuth.authState.pipe(
      switchMap(user => {
        if (user) {
          this.pn = user.phoneNumber;
          this.uid = user.uid;
          this._isAuthenticated = true;
          return this.getClient(user.uid);
        } else {
          this.pn = null;
          this.uid = null;
          this._isAuthenticated = false;
          return of(null);
        }
      })
    );
  }

  get isAuthenticated(): boolean {
    return this._isAuthenticated;
  }

  get windowRef() {
    return window;
  }

  getError(code: string): string {
    return this.errors[code];
  }

  /** */
  getClient(uid: string) {
    return this.db.object<Cliente>(`clients/${uid}`).valueChanges();
  }

  updateUser(cliente: Cliente) {
    return this.db.object(`${AuthService.CLIENTS_REF}/${cliente.uid}`).update(cliente);
  }

  signOut() {
    return this.afAuth.signOut();
  }
}
